<div class="top">
  <div class="heading">
    <h1>Current Tasks</h1>

    <div class="menuButton">
      <button class="options" mat-icon-button
              aria-label="Current list menu" title="Current list menu"
              [matMenuTriggerFor]="listMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </div>

  <div id="table-container" [hidden]="!dataLoaded">
    <div class="scrollable">
      <table id="tasks-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="done">
          <td class="title" mat-cell *matCellDef="let task">
            <mat-checkbox [checked]="isTaskClosed(task)"
                          (change)="toggleClosed(task)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="title">
          <td class="title" mat-cell *matCellDef="let task">
            <a routerLink="../task/{{task.id}}" [className]="isTaskClosed(task) ? 'closed' : 'open'">
              {{task.title}}
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="options">
          <td mat-cell *matCellDef="let task">
            <button class="options" mat-icon-button
                    aria-label="Task options menu" title="Task options menu"
                    [matMenuTriggerFor]="singleTaskMenu"
                    [matMenuTriggerData]="{task: task}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let task; columns: displayedColumns;"
          [className]="isTaskClosed(task) ? 'closed' : 'open'"></tr>
      </table>
    </div>
  </div>

  <app-command-bar></app-command-bar>

  <div [hidden]="dataLoaded">
    <mat-spinner></mat-spinner>
  </div>
</div>

<mat-menu #listMenu="matMenu" yPosition="below">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="archiveNameDialog.showModal()">
      Archive Current List
    </button>
  </ng-template>
</mat-menu>

<mat-menu #singleTaskMenu="matMenu" yPosition="below">
  <ng-template matMenuContent let-task="task">
    <button mat-menu-item (click)="removeFromCurrent(task)">
      Remove from Current
    </button>
    <button mat-menu-item (click)="deleteTask(task)">
      Delete
    </button>
    <button mat-menu-item [routerLink]="'/edit-task/' + task.id">
      Edit
    </button>
  </ng-template>
</mat-menu>

<dialog id="archiveNameDialog">
  <form method="dialog">
    <section>
      <label for="archiveName">Enter a name for the archived list:</label>
      <input #archiveName type="text" name="archiveName">
    </section>
    <menu>
      <button id="cancel" type="reset" (click)="archiveNameDialog.close()">Cancel</button>
      <button type="submit" (click)="archiveNameDialog.close(archiveName.value)">Confirm</button>
    </menu>
  </form>
</dialog>